import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-close-current-tab',
    templateUrl: './close-current-tab.component.html',
    styleUrls: ['./close-current-tab.component.scss'],
    standalone: false
})
export class CloseCurrentTabComponent implements OnInit {

  ngOnInit() {
    window.close();
  }

}
